<script lang="ts">
  import { ui } from '../game/store.ts';
  import { game } from '../game/game.ts';
  import { t } from '../i18n.ts';
  import { OUTFITS } from '../engine/character.ts';

  const d = $derived($ui.dialog!);
  const color = $derived((OUTFITS as any)[d.who]?.coat ?? '#e0a346');

  function onKey(e: KeyboardEvent) {
    if (!d.choices && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      game.dialogAdvance('next');
    } else if (d.choices && /^[1-9]$/.test(e.key)) {
      const c = d.choices[Number(e.key) - 1];
      if (c) game.dialogAdvance(c.id);
    }
  }
</script>

<svelte:window onkeydown={onKey} />

<div class="dlg" class:portrait={$ui.portrait} role="dialog" aria-label={d.name} data-testid="dialog">
  <div class="panel box">
    <div class="who">
      <span class="badge" style:background={color}>{d.name.slice(0, 1)}</span>
      <span class="name">{d.choices ? t('dialog.yourAnswer') : d.name}</span>
    </div>
    {#if d.choices}
      <div class="choices">
        {#each d.choices as c, i}
          <button class="choice" onclick={() => game.dialogAdvance(c.id)} data-testid={'choice-' + c.id}>
            <span class="n">{i + 1}</span>{c.label}
          </button>
        {/each}
      </div>
    {:else}
      <button class="line" onclick={() => game.dialogAdvance('next')} data-testid="dialog-next" aria-live="polite">
        {d.text}
        <span class="more" aria-hidden="true">▸</span>
      </button>
    {/if}
  </div>
</div>

<style>
  .dlg {
    position: fixed;
    left: 50%;
    bottom: calc(96px + var(--safe-bottom));
    transform: translateX(-50%);
    width: min(720px, calc(100% - 24px));
    z-index: 32;
    animation: up 0.2s ease-out both;
  }
  .dlg.portrait {
    bottom: calc(12px + var(--safe-bottom));
  }
  @keyframes up {
    from {
      opacity: 0;
      transform: translate(-50%, 10px);
    }
  }
  .box {
    padding: 14px 16px 16px;
  }
  .who {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
  }
  .badge {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    font-family: var(--font-display);
    font-weight: 800;
    color: var(--ink);
    box-shadow: 0 0 0 2px var(--brass2);
  }
  .name {
    font-family: var(--font-display);
    font-weight: 600;
    color: var(--amber2);
    font-size: 1.1rem;
  }
  .line {
    display: block;
    width: 100%;
    text-align: left;
    background: none;
    border: 0;
    padding: 0;
    font-size: 1.1rem;
    line-height: 1.5;
    min-height: 48px;
  }
  .more {
    display: inline-block;
    margin-left: 6px;
    color: var(--amber2);
    animation: blink 1.2s infinite;
  }
  @keyframes blink {
    50% {
      opacity: 0.3;
    }
  }
  .choices {
    display: grid;
    gap: 8px;
  }
  .choice {
    display: flex;
    gap: 10px;
    align-items: center;
    text-align: left;
    min-height: 48px;
    padding: 8px 12px;
    border-radius: 12px;
    border: 1.5px solid rgba(226, 194, 122, 0.35);
    background: rgba(12, 20, 34, 0.5);
  }
  .choice:hover,
  .choice:focus-visible {
    border-color: var(--amber2);
    outline: none;
    background: rgba(58, 85, 120, 0.55);
  }
  .n {
    width: 24px;
    height: 24px;
    flex: none;
    border-radius: 50%;
    background: var(--brass1);
    color: var(--ink);
    font-weight: 800;
    font-size: 0.8rem;
    display: grid;
    place-items: center;
  }
</style>
